export type ChatbaseProps = {
  callback: () => void;
};

export const loadChatbase = ({ callback }: ChatbaseProps) => {
  callback && callback();
};

export const getChatbaseInitData = () => {
  return {
    callback: () => console.info('Chatbase BOT loaded.'),
  };
};
